import { render, staticRenderFns } from "./BbnwResources.vue?vue&type=template&id=a905ea76&scoped=true&"
import script from "./BbnwResources.vue?vue&type=script&lang=js&"
export * from "./BbnwResources.vue?vue&type=script&lang=js&"
import style0 from "./BbnwResources.vue?vue&type=style&index=0&id=a905ea76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a905ea76",
  null
  
)

export default component.exports